/* Menue, Warenkorb-Drawer, Add-to-Cart, mobiler Sticky-CTA.
   Ohne JavaScript funktioniert alles: das Produktformular submittet nativ auf /cart,
   das Warenkorb-Icon ist ein Link auf /cart, das Menue oeffnet nicht, aber die
   Navigation steht auch im Footer. */
(() => {
  const SECTION = 'nc-cart-drawer';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function bindDialog(id, openSelector) {
    const dlg = document.getElementById(id);
    if (!dlg || dlg.dataset.bound) return;
    dlg.dataset.bound = '1';
    $$(openSelector).forEach((el) =>
      el.addEventListener('click', (e) => { e.preventDefault(); dlg.showModal(); })
    );
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) dlg.close(); });
  }

  function applyCart(html) {
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#nc-cart-content');
    const current = document.getElementById('nc-cart-content');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    const badge = document.querySelector('[data-cart-count]');
    if (badge) {
      const n = Number(fresh.dataset.count || 0);
      badge.textContent = n > 0 ? String(n) : '';
    }
  }

  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTION })
    });
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    btn.disabled = true;
    try {
      const data = await post('/cart/change.js', {
        id: btn.dataset.cartQty,
        quantity: Number(btn.dataset.value)
      });
      applyCart(data.sections[SECTION]);
    } catch (err) {
      window.location.href = '/cart';
    }
  });

  // "Passt dazu" im Drawer: Ein-Klick-Hinzufuegen, delegiert wie data-cart-qty,
  // damit es auch nach jedem Section-Rerender ohne Neu-Binden funktioniert.
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-add]');
    if (!btn) return;
    btn.disabled = true;
    try {
      const data = await post('/cart/add.js', {
        items: [{ id: Number(btn.dataset.cartAdd), quantity: 1 }]
      });
      applyCart(data.sections[SECTION]);
    } catch (err) {
      window.location.href = '/cart';
    }
  });

  // Ausverkauft (21.09.2026): der Kaufknopf hat dann type="button" und oeffnet
  // den Hinweis unter dem Formular. Delegiert, damit es auch nach dem
  // Farbwechsel ohne Neu-Binden greift. Aus der Sticky-Leiste heraus wird der
  // Hinweis in den Blick geholt, sonst stuende er unsichtbar weiter oben.
  document.addEventListener('click', (e) => {
    const knopf = e.target.closest('[data-nc-cta]');
    if (knopf && knopf.type === 'button') {
      const hinweis = document.getElementById('NcAusverkauft');
      if (!hinweis) return;
      hinweis.hidden = false;
      if (knopf.closest('.nc-sticky')) hinweis.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const link = e.target.closest('[data-nc-zum-newsletter]');
    if (!link) return;
    const feld = document.getElementById('NcNewsletterEmail');
    if (!feld) return;                  // ohne Fusszeile bleibt es ein normaler Anker
    e.preventDefault();
    feld.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => feld.focus({ preventScroll: true }), 500);
  });

  function bindProductForm() {
    const form = document.getElementById('NcProductForm');
    const drawer = document.getElementById('NcCartDrawer');
    if (!form || !drawer || form.dataset.bound) return;
    form.dataset.bound = '1';
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const buttons = $$('button[type="submit"]', document).filter(
        (b) => b.form === form || b.closest('form') === form
      );
      buttons.forEach((b) => (b.disabled = true));
      try {
        const data = await post('/cart/add.js', {
          items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }]
        });
        applyCart(data.sections[SECTION]);
        drawer.showModal();
      } catch (err) {
        window.location.href = '/cart';   // 422 oder Netzfehler: sauber weiterreichen
      } finally {
        buttons.forEach((b) => (b.disabled = false));
      }
    });
  }

  // Sticky-Guard der Infospalte: Ist die Bildspalte kuerzer als das Fenster,
  // wird die Infospalte nicht sticky gesetzt (Auftrag Schritt 8). Passiert,
  // solange ein Produkt nur ein Bild hat.
  //
  // Die Pruefung haengt seit A6 auch am Farbwechsel: blendet die Galerie eine
  // Mediengruppe um, aendert sich die Hoehe der Bildspalte. pdpPruefe haelt die
  // Funktion dafuer bereit.
  let pdpPruefe = null;

  function bindPdpSticky() {
    const media = document.querySelector('.nc-pdp__media');
    const info = document.querySelector('.nc-pdp__info');
    if (!media || !info) return;
    const pruefe = () => {
      info.classList.toggle('is-statisch', media.offsetHeight <= window.innerHeight);
    };
    pdpPruefe = pruefe;
    if (info.dataset.bound) return;
    info.dataset.bound = '1';
    pruefe();
    addEventListener('resize', pruefe);
  }

  function bindStickyCta() {
    const cta = document.getElementById('NcAddButton');
    const bar = document.getElementById('NcStickyBar');
    if (!cta || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(
      ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting),
      { rootMargin: '0px 0px -24px 0px' }
    ).observe(cta);
  }

  // Die Panel-Strecke der Startseite, Sollwerte 2.3 und 2.1 des Messberichts:
  //
  // 1. Nur auf dem ERSTEN Panel ist die Kopfzeile transparent. Ab dem zweiten wird
  //    sie ein deckend weisser Balken mit dunkler Schrift und dunklen Symbolen, die
  //    kleine Wortmarke sitzt mittig darauf. Das ist Pius' Entscheidung vom
  //    13.08.2026 frueh nach dem Review seiner Bildschirmaufnahme und ersetzt
  //    Abweichung Nr. 1, nach der die Kopfzeile ueber die ganze Strecke transparent
  //    blieb und nur die Schriftfarbe wechselte. Grund: eine halb auf dem
  //    Kampagnenbild liegende Wortmarke war auf keinem seiner Referenz-Screenshots.
  //    is-dunkel bleibt fuer den einen verbliebenen transparenten Fall, ein erstes
  //    Panel mit dunkler Schrift (ohne Bild ist es immer dunkel, siehe F3).
  // 2. Auf dem ersten Panel ist die Kopfzeile 86px hoch und die Wortmarke per
  //    transform: scale() auf Fensterbreite minus zweimal Seitenabstand gebracht.
  //    Ab dem zweiten Panel faellt beides mit 0,5s auf den Normalzustand.
  // 3. Unten mittig steht ein Zaehler "2 / 5". Die Fusszeile zaehlt als letztes
  //    Panel mit (2.1), die Gesamtzahl wird zur Laufzeit gelesen. Auf dem ersten
  //    Panel steht stattdessen der Scroll-Hinweis, der beim ersten Scrollen
  //    verschwindet.
  //
  // Der Zaehler wird hier erzeugt und nicht in Liquid, weil er zur ganzen Strecke
  // gehoert und nicht zu einer einzelnen Section.
  function bindPanels() {
    const header = document.querySelector('.nc-header--transparent');
    // Sections, deren Liquid nichts ausgibt, sind per CSS unsichtbar und
    // zaehlen nicht als Panel.
    const panels = Array.from(document.querySelectorAll('.nc-panel')).filter(
      (p) => p.firstElementChild
    );
    if (!panels.length || !('IntersectionObserver' in window)) return;
    // init() laeuft im Theme-Editor bei jedem Section-Load erneut. Der alte
    // Beobachter und der alte resize-Listener muessen vorher weg, sonst
    // schreiben sie den Zaehler mit veralteter Gesamtzahl zurueck.
    if (window.__ncPanelsAufraeumen) window.__ncPanelsAufraeumen();

    // Der Panel-Zaehler ("2 / 3" unten mittig, Sollwert 2.3 der Referenz) wird
    // seit dem 05.09.2026 nicht mehr erzeugt: Pius hat das Einrasten auch am
    // Desktop abgeschafft ("die erste seite komplett in einem scroll"), und ohne
    // Einrasten zaehlt er nichts, was der Besucher als Schritt erlebt. Der
    // Beobachter unten bleibt, er steuert weiter die Kopfzeile (transparent
    // ueber dem Parkdeck, deckend ab dem Produktpanel).

    // Horizon sperrt html und body ab 990px auf overflow:hidden, gescrollt wird
    // dann INNERHALB von .page-wrapper (base.css Zeile 36). window.scrollY bleibt
    // dort immer 0. Der Capture-Listener auf document faengt auch die
    // Scroll-Ereignisse des inneren Containers.
    const hinweis = document.querySelector('[data-nc-scrollhinweis]');
    if (hinweis && !hinweis.dataset.bound) {
      hinweis.dataset.bound = '1';
      const wrapper = document.querySelector('.page-wrapper');
      const scrollPos = () => Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
      document.addEventListener('scroll', () => {
        if (scrollPos() > 40) hinweis.classList.add('is-weg');
      }, { capture: true, passive: true });
    }

    // Wortmarken-Skalierung wie die Referenz: (Fensterbreite - 2 * Seitenabstand)
    // geteilt durch die gemessene Basisbreite. Die Referenz deckelt den Faktor
    // auf dem Desktop, am 13.08.2026 live gemessen: --scale-value stand auf
    // 10,76, angewendet war 3,30, das Logo fuellt 81,3px der 113px hohen grossen
    // Kopfzeile, Verhaeltnis 0,7195. Derselbe Deckel hier ueber die Hoehe:
    // die skalierte Marke darf hoechstens 0,7195 mal 86px hoch werden.
    // Neu gerechnet bei resize und sobald die Schrift geladen ist, vorher misst
    // offsetWidth die Ersatzschrift.
    // Dritter Deckel, am 14.08.2026 nach Pius' Fund ergaenzt: die Marke steht
    // absolut in der Bildmitte, links und rechts liegen Burger, Lupe, Konto und
    // Warenkorb. Bis dahin rechnete die Formel mit der vollen Fensterbreite und
    // schob die Marke ueber die Symbole. Gemessen: bei 390px verdeckte sie beide
    // Bloecke vollstaendig (je 64px), bei 493px noch 21px je Seite. Betroffen war
    // jedes Fenster unter rund 555px, also jedes Handy. Weil die Marke zentriert
    // ist, ist der freie Raum symmetrisch, also zaehlt der breitere der beiden
    // Bloecke. 12px Luft, damit sie nicht am Symbol klebt.
    const marke = header ? header.querySelector('.nc-marke') : null;
    function skaliere() {
      if (!marke) return;
      const seitenabstand = parseFloat(getComputedStyle(header).paddingLeft) || 16;
      const basisBreite = marke.offsetWidth;
      const basisHoehe = marke.offsetHeight;
      if (basisBreite > 0 && basisHoehe > 0) {
        const bloecke = header.querySelectorAll('.nc-header__side');
        const mitte = window.innerWidth / 2;
        let halberRaum = Infinity;
        bloecke.forEach((b) => {
          const r = b.getBoundingClientRect();
          // Nicht die Breite der Bloecke rechnen, sondern ihre Innenkanten messen.
          // Die Breite allein unterschlaegt den Seitenabstand, und dann bleiben vier
          // Pixel Ueberdeckung stehen.
          const innen = r.left < mitte ? mitte - r.right : r.left - mitte;
          halberRaum = Math.min(halberRaum, innen);
        });
        const freierRaum = 2 * Math.max(0, halberRaum - 12);
        const breitenFaktor = (window.innerWidth - 2 * seitenabstand) / basisBreite;
        const symbolDeckel = freierRaum / basisBreite;
        const hoehenDeckel = (86 * 0.7195) / basisHoehe;
        header.style.setProperty(
          '--nc-scale',
          Math.max(1, Math.min(breitenFaktor, symbolDeckel, hoehenDeckel)).toFixed(4)
        );
      }
    }
    if (marke) {
      skaliere();
      addEventListener('resize', skaliere);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(skaliere);
    }

    const fusszeile = document.querySelector('.nc-footer');
    const gesamt = panels.length + (fusszeile ? 1 : 0);

    // deckend haengt allein am Index: Panel 1 transparent, alles danach deckend.
    // hell steuert nur noch den einen transparenten Fall.
    function setze(i, hell) {
      const deckend = i > 0;
      if (header) {
        header.classList.toggle('is-gross', i === 0);
        header.classList.toggle('is-deckend', deckend);
        header.classList.toggle('is-dunkel', !deckend && !hell);
      }
    }

    const beobachter = new IntersectionObserver((eintraege) => {
      eintraege.forEach((e) => {
        if (!e.isIntersecting) return;
        if (e.target === fusszeile) {
          setze(gesamt - 1, false);
          return;
        }
        const i = panels.indexOf(e.target);
        const hell = !!e.target.querySelector('.nc-panel--hell');
        setze(i, hell);
      });
      // Erkannt wird das Panel, das die Fenstermitte bedeckt: rootMargin schrumpft
      // den Beobachtungsbereich auf eine waagerechte Linie in halber Fensterhoehe.
      //
      // Vorher stand hier threshold 0.55, und das war ab dem 13.08.2026 kaputt.
      // Seit alle zwoelf Kacheln in EINEM Panel liegen (A3), ist dieses Panel nach
      // dem Aufklappen 1548px hoch. 55 Prozent davon sind 851px und passen nie in
      // ein 787px hohes Fenster, der Beobachter feuerte fuer dieses Panel also gar
      // nicht mehr. Der Zaehler sprang von 1/3 auf 3/3 und die Kopfzeile blieb bis
      // zur Fusszeile gross. Mit der Mittellinie ist die Panelhoehe gleichgueltig.
    }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
    panels.forEach((p) => beobachter.observe(p));
    if (fusszeile) beobachter.observe(fusszeile);

    window.__ncPanelsAufraeumen = () => {
      beobachter.disconnect();
      removeEventListener('resize', skaliere);
    };
  }

  // Das Radraster-JS (bindPanelRad, 18.08.2026: eine Mausrad-Raste oder
  // PageDown schaltete am Desktop genau ein Panel weiter, weil das
  // mandatory-Einrasten kleine Radschritte sonst zurueckzog) ist seit dem
  // 05.09.2026 entfernt. Pius: "die erste seite komplett in einem scroll",
  // damit gibt es kein Einrasten mehr und Rad wie Tastatur scrollen wieder
  // nativ. Die Fassung steht im git-Verlauf vor dem 05.09.2026.

  // Teilen-Panel der Produktseite (Pius, 18.08.2026): WhatsApp ist ein purer
  // Link (wa.me, im Liquid gebaut). Instagram kennt im Web kein direktes
  // Teilen, deshalb oeffnet der Punkt das System-Teilen-Blatt, wo es eins
  // gibt (dort waehlt man Instagram), und kopiert sonst den Link mit einem
  // Hinweis. Link kopieren schreibt in die Zwischenablage und bestaetigt.
  function bindTeilen() {
    const panel = document.getElementById('NcPanelTeilen');
    if (!panel || panel.dataset.teilenBound) return;
    panel.dataset.teilenBound = '1';
    const liste = panel.querySelector('.nc-teilen');
    const meldung = panel.querySelector('[data-teilen-meldung]');
    const url = liste.dataset.teilenUrl;

    function sage(text) {
      meldung.textContent = text;
      meldung.hidden = false;
    }
    panel.addEventListener('close', () => { meldung.hidden = true; });

    async function kopiere(hinweis) {
      try {
        await navigator.clipboard.writeText(url);
        sage(hinweis);
      } catch (err) {
        sage(url);              // Zwischenablage verweigert: Link zum Abschreiben zeigen
      }
    }

    panel.querySelector('[data-teilen-link]').addEventListener('click', () => kopiere('Link kopiert.'));
    // Instagram, vierte Iteration (Pius, 18.08.): auch das System-Teilen-Blatt
    // als Zwischenschritt ist unerwuenscht, die App soll DIREKT aufgehen und
    // die Kontaktwahl zeigen. Der einzige Weg dahin ist das inoffizielle
    // App-Scheme instagram://sharesheet mit dem Link als text-Parameter.
    // Ob Instagrams App-Version damit das "Share link"-Sheet oeffnet oder nur
    // die App, entscheidet Instagram, deshalb liegt der Link vorher in der
    // Zwischenablage. Oeffnet binnen 1,5s keine App (Seite blieb sichtbar),
    // springt der Universal Link auf die Neue-Nachricht-Ansicht. Am Desktop
    // unveraendert: kopieren plus Empfaengerwahl im Web.
    panel.querySelector('[data-teilen-instagram]').addEventListener('click', async () => {
      const mobil = matchMedia('(any-pointer: coarse)').matches;
      if (mobil) {
        await kopiere('Link kopiert. In Instagram einfügen.');
        const t = setTimeout(() => {
          if (!document.hidden) window.location.href = 'https://www.instagram.com/direct/new/';
        }, 1500);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) clearTimeout(t);
        }, { once: true });
        window.location.href = 'instagram://sharesheet?text=' + encodeURIComponent(url);
      } else {
        await kopiere('Link kopiert. In Instagram Empfänger wählen und einfügen.');
        window.open('https://www.instagram.com/direct/new/', '_blank', 'noopener');
      }
    });
  }

  // Solange der Shopify-Cookie-Banner unbeantwortet unten liegt, bekommt die
  // Fusszeile ein Polster in genau seiner Hoehe, sonst verdeckt er am
  // Seitenende die untersten Rechtliches-Links (Befund Test-Session 18.08.,
  // nach der Kompaktierung noch AGB, Widerruf, Versand). Nach der Antwort
  // setzt Shopify display:none, der Beobachter raeumt das Polster weg.
  function bindBannerPolster() {
    const doc = document.documentElement;
    const pruefe = () => {
      const b = document.getElementById('shopify-pc__banner');
      const offen = !!(b && getComputedStyle(b).display !== 'none');
      doc.classList.toggle('nc-banner-offen', offen);
      doc.style.setProperty('--nc-banner-h', offen ? b.getBoundingClientRect().height + 'px' : '0px');
    };
    // Der Banner kommt asynchron aus Shopifys Script. Erst auf sein Erscheinen
    // warten (childList am body, ohne subtree, das ist billig), dann nur noch
    // sein style-Attribut beobachten. Ein Beobachter auf dem ganzen Baum
    // wuerde bei jeder DOM-Aenderung Layout messen.
    let bannerMo = null;
    const finde = () => {
      const b = document.getElementById('shopify-pc__banner');
      if (!b || bannerMo) return b;
      bannerMo = new MutationObserver(pruefe);
      bannerMo.observe(b, { attributes: true, attributeFilter: ['style', 'class'] });
      pruefe();
      return b;
    };
    if (!finde()) {
      const wart = new MutationObserver(() => { if (finde()) wart.disconnect(); });
      wart.observe(document.body, { childList: true });
    }
  }

  // Klick auf die Wortmarke, waehrend man schon auf der Zielseite steht: nach
  // oben scrollen statt neu laden. Safari behandelt den Link auf dieselbe URL
  // als Reload und stellt danach die alte Scrollposition wieder her, in Pius'
  // iPhone-Videos vom 18.08.2026 landete man damit mitten im Cap-Grid statt
  // oben bei den Polaroids. Beide Scroller ansprechen: ab 990px scrollt
  // .page-wrapper, darunter das Dokument.
  function bindLogoTop() {
    const logo = document.querySelector('.nc-header__logo');
    if (!logo || logo.dataset.topBound) return;
    logo.dataset.topBound = '1';
    logo.addEventListener('click', (e) => {
      if (new URL(logo.href, location.href).pathname !== location.pathname) return;
      e.preventDefault();
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) wrapper.scrollTo({ top: 0, behavior: 'smooth' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // Der Knopf haengt nur Zeilen an: is-offen hebt das :nth-child-Ausblenden in
  // no-capital.css auf, grid-template-columns bleibt unangetastet (D2). Danach
  // verschwindet der Knopf, einen belegten Wortlaut fuers Zuklappen gibt es nicht.
  function bindMehr() {
    document.querySelectorAll('[data-nc-mehr]').forEach((knopf) => {
      if (knopf.dataset.bound) return;
      knopf.dataset.bound = '1';
      const raster = knopf.closest('[data-nc-raster]');
      knopf.addEventListener('click', () => {
        raster.classList.add('is-offen');
        knopf.setAttribute('aria-expanded', 'true');
      });
    });
  }

  // Punkte des Bildkarussells in der Kachel (unter 1024px). Beobachtet wird im
  // Scroll-Container selbst, der aktive Punkt folgt dem eingerasteten Bild.
  // Ohne JavaScript bleiben beide Punkte stehen, der erste aktiv, das Karussell
  // selbst laeuft rein per CSS-Snap.
  function bindCardDots() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-nc-slides]').forEach((slides) => {
      if (slides.dataset.bound) return;
      const dots = slides.parentElement.querySelectorAll('.nc-card__dot');
      if (dots.length < 2) return;
      slides.dataset.bound = '1';
      const kinder = Array.from(slides.children);
      const beobachter = new IntersectionObserver((eintraege) => {
        eintraege.forEach((e) => {
          if (!e.isIntersecting) return;
          const i = kinder.indexOf(e.target);
          dots.forEach((d, di) => d.classList.toggle('is-aktiv', di === i));
        });
      }, { root: slides, threshold: 0.6 });
      kinder.forEach((k) => beobachter.observe(k));
    });
  }

  // Farbwahl auf der Produktseite. Ohne JavaScript bleibt die erste Variante
  // ausgewaehlt und das Formular funktioniert, es laesst sich nur nicht wechseln.
  // Deshalb setzt Liquid die Variante schon serverseitig aus ?variant= in der URL.
  function bindVariants() {
    const daten = document.querySelector('[data-nc-variants]');
    const feld = document.querySelector('[data-nc-variant-id]');
    if (!daten || !feld || daten.dataset.bound) return;
    daten.dataset.bound = '1';

    let varianten;
    try {
      varianten = JSON.parse(daten.textContent);
    } catch (err) {
      return;                       // lieber gar kein Picker als ein kaputter
    }

    const fieldsets = $$('.nc-optionen');
    const galerie = document.querySelector('.nc-pdp__media');

    // Nach Position statt nach Reihenfolge: eine Option, deren einziger Wert keine
    // belegte Farbe hat, rendert ihre Knopfreihe gar nicht, dann fehlt in diesem
    // Fieldset jedes input. Ein Abgleich ueber den Index waere danach um eine
    // Stelle verschoben.
    function gewaehlt() {
      const wahl = {};
      fieldsets.forEach((fs) => {
        const treffer = fs.querySelector('input:checked');
        if (treffer) wahl[Number(fs.dataset.optionPosition) - 1] = treffer.value;
      });
      return wahl;
    }

    function wechsle() {
      const wahl = gewaehlt();
      const stellen = Object.keys(wahl);
      if (!stellen.length) return;
      const treffer = varianten.find((v) => stellen.every((i) => v.options[i] === wahl[i]));
      if (!treffer) return;

      feld.value = treffer.id;
      $$('[data-nc-price]').forEach((el) => (el.textContent = treffer.price));
      // Nur die Kaufknoepfe des Produktformulars (data-nc-cta), sonst traefe es
      // auch den Kassenknopf im Warenkorb-Drawer, der auf jeder Seite im DOM liegt.
      // Seit 21.09.2026 bleibt ein ausverkaufter Knopf klickbar: Typ "button"
      // statt "submit", der Klick oeffnet den Hinweis (bindAusverkauft).
      $$('[data-nc-cta]').forEach((b) => {
        b.type = treffer.available ? 'submit' : 'button';
        b.disabled = false;
        b.classList.toggle('nc-button--aus', !treffer.available);
        b.textContent = treffer.available
          ? b.closest('.nc-sticky') ? 'In den Warenkorb' : 'Zum Warenkorb hinzufügen'
          : 'Ausverkauft';
      });
      const hinweis = document.getElementById('NcAusverkauft');
      if (hinweis && treffer.available) hinweis.hidden = true;

      fieldsets.forEach((fs) => {
        const pos = fs.dataset.optionPosition;
        const ziel = fs.parentElement.querySelector(`[data-option-selected="${pos}"]`);
        if (ziel) ziel.textContent = wahl[Number(pos) - 1] ?? ziel.textContent;
      });

      // A6: Ist die Galerie nach Farben gruppiert, wird umgeblendet statt
      // gescrollt. Rahmen ohne data-nc-gruppe stehen vor der ersten Gruppe und
      // bleiben immer sichtbar, sie werden hier gar nicht erst angefasst.
      if (galerie && 'ncGruppiert' in galerie.dataset) {
        galerie.querySelectorAll('[data-nc-gruppe]').forEach((rahmen) => {
          rahmen.classList.toggle('is-weg', rahmen.dataset.ncGruppe !== String(treffer.id));
        });
        // Mobil ist die Galerie ein waagerechter Scroller. Nach dem Umblenden
        // steht sie sonst mitten in der alten Bildfolge. Auf dem Desktop ist der
        // Aufruf wirkungslos, dort scrollt die Seite und nicht die Spalte.
        galerie.scrollLeft = 0;
        if (pdpPruefe) pdpPruefe();
      } else if (treffer.mediaId && galerie) {
        const bild = galerie.querySelector(`[data-media-id="${treffer.mediaId}"]`);
        // Auf dem Desktop stapeln sich die Bilder senkrecht und die Seite scrollt,
        // auf dem Handy liegen sie waagerecht im Karussell. scrollIntoView mit
        // block:nearest laesst die Seite auf dem Desktop in Ruhe und schiebt mobil
        // nur das Karussell.
        if (bild) bild.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', treffer.id);
      window.history.replaceState({}, '', url);
    }

    fieldsets.forEach((fs) => fs.addEventListener('change', wechsle));
  }

  // Text auf die Breite seines Kastens bringen. Zwei Stellen nutzen das: die
  // Wortmarke in der Fusszeile und das COMING SOON einer leeren Kategorie.
  //
  // Sollwert, am 14.08.2026 im laufenden Frontend der Referenz gemessen: die
  // Wortmarke der Fusszeile ist 1621px breit bei 1653px Fensterbreite, also
  // Fensterbreite minus zweimal 16px Seitenabstand. Dieselbe Formel wie bei der
  // grossen Kopfmarke auf Panel 1, und sie gilt dort auf jeder Seite.
  //
  // Gerechnet wird ueber font-size, nicht ueber transform: scale(). Ein
  // transform aendert den Platzbedarf nicht, die Copyrightzeile wuerde die Marke
  // ueberlappen und muesste per JS eine Hoehe zugewiesen bekommen. Ueber
  // font-size fliesst das Layout von selbst.
  //
  // Vor dem Messen auf eine feste Basisgroesse setzen. Nur so ist der Lauf
  // wiederholbar: sonst misst der zweite resize die bereits skalierte Marke und
  // der Wert driftet.
  //
  // Gemessen wird ueber eine Range, nicht ueber offsetWidth oder scrollWidth.
  // Die Marke erbt display:block aus .nc-marke, und ein Block ist immer so breit
  // wie sein Kasten. Beide Werte melden damit die Kastenbreite und der Faktor
  // kommt auf 1, die Schrift bleibt auf der Basisgroesse stehen. Am 14.08.2026
  // genau so passiert: das COMING SOON stand auf 100px und die Messung meldete
  // trotzdem "Breite gleich Sollbreite". Eine Range um den Textinhalt misst den
  // Text selbst, unabhaengig vom Kasten und ohne das Layout anzufassen.
  const RIESIG_BASIS = 100;
  function textbreite(el) {
    const bereich = document.createRange();
    bereich.selectNodeContents(el);
    return bereich.getBoundingClientRect().width;
  }
  function riesig(el) {
    const kasten = el.parentElement;
    if (!kasten) return;
    const stil = getComputedStyle(kasten);
    const ziel =
      kasten.clientWidth -
      (parseFloat(stil.paddingLeft) || 0) -
      (parseFloat(stil.paddingRight) || 0);
    if (ziel <= 0) return;
    el.style.fontSize = RIESIG_BASIS + 'px';
    const breite = textbreite(el);
    if (breite <= 0) return;
    el.style.fontSize = ((RIESIG_BASIS * ziel) / breite).toFixed(2) + 'px';
  }
  let riesigGebunden = false;
  function bindRiesig() {
    const rechne = () => $$('[data-nc-riesig]').forEach(riesig);
    if (!$$('[data-nc-riesig]').length) return;
    rechne();
    if (riesigGebunden) return;
    riesigGebunden = true;
    addEventListener('resize', rechne);
    // Vor dem Schriftladen misst der Browser die Ersatzschrift, dieselbe Falle
    // wie bei der Kopfmarke.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(rechne);
  }

  // Ziehbalken der Produktstrecke unter der Produktseite, docs/todos.md Nr. 86.
  //
  // Ohne JavaScript funktioniert die Strecke vollstaendig: sie scrollt per CSS,
  // mit Finger, Trackpad und Tastatur. Der Balken ist das Einzige, was hier
  // dazukommt, deshalb steht er in Liquid auf hidden und wird erst hier
  // eingeblendet. Ein Balken, der sich nicht bewegt, waere schlechter als keiner.
  //
  // Er blendet sich auch dann nicht ein, wenn alle Kacheln ins Fenster passen.
  // Dann gibt es nichts zu ziehen, und die Strecke gehoert eigentlich ins Raster.
  let streckeGebunden = false;
  function bindStrecke() {
    $$('[data-nc-strecke]').forEach((reihe) => {
      const eltern = reihe.parentElement;
      const ziehen = eltern && eltern.querySelector('[data-nc-ziehen]');
      const bahn = ziehen && ziehen.querySelector('[data-nc-bahn]');
      const griff = ziehen && ziehen.querySelector('[data-nc-griff]');
      if (!bahn || !griff) return;

      // Breite des Griffs ist der sichtbare Anteil der Strecke, seine Lage der
      // Scrollstand. Beides in Prozent der Bahn, damit ein Fensterwechsel nichts
      // nachrechnen muss, was das Layout schon weiss.
      const zeichne = () => {
        const anteil = reihe.clientWidth / reihe.scrollWidth;
        ziehen.hidden = !(anteil < 0.999);
        if (ziehen.hidden) return;
        const rest = reihe.scrollWidth - reihe.clientWidth;
        const weg = rest > 0 ? reihe.scrollLeft / rest : 0;
        griff.style.width = (anteil * 100).toFixed(3) + '%';
        griff.style.left = (weg * (100 - anteil * 100)).toFixed(3) + '%';
      };

      if (!reihe.dataset.bound) {
        reihe.dataset.bound = '1';
        reihe.addEventListener('scroll', zeichne, { passive: true });

        // Gerechnet wird auf die MITTE des Griffs. Sonst springt ein Klick neben
        // den Griff um eine halbe Griffbreite daneben, und beim Ziehen wandert
        // der Griff unter dem Finger weg.
        const fahre = (x) => {
          const b = bahn.getBoundingClientRect();
          const g = griff.getBoundingClientRect().width;
          const platz = b.width - g;
          if (platz <= 0) return;
          const anteil = Math.min(Math.max((x - b.left - g / 2) / platz, 0), 1);
          reihe.scrollLeft = anteil * (reihe.scrollWidth - reihe.clientWidth);
        };

        // Die Ereignisse haengen am BAND, nicht an der Linie. Die Linie ist 1px
        // hoch, das Band 45. Am 14.08.2026 nachgemessen: mit den Ereignissen an
        // der Linie tut ein Griff schon 3px daneben gar nichts mehr, und der
        // Balken waere auf dem Desktop trotzdem die einzige sichtbare Bedienung
        // der Strecke. Ein Test, der genau auf die Linie zielt, sieht das nicht.
        let zeiger = null;
        ziehen.addEventListener('pointerdown', (e) => {
          if (e.button > 0) return;          // nur die Haupttaste zieht
          if (zeiger !== null) return;       // ein zweiter Finger fasst nicht mit an
          zeiger = e.pointerId;
          ziehen.setPointerCapture(e.pointerId);
          // Einrasten aus, solange gezogen wird. Sonst zieht das Snapping jedes
          // gesetzte scrollLeft wieder zurueck und der Griff zappelt.
          reihe.classList.add('is-zieht');
          fahre(e.clientX);
          e.preventDefault();
        });
        ziehen.addEventListener('pointermove', (e) => {
          if (e.pointerId === zeiger) fahre(e.clientX);
        });
        const los = (e) => {
          if (e.pointerId !== zeiger) return;
          if (ziehen.hasPointerCapture(e.pointerId)) ziehen.releasePointerCapture(e.pointerId);
          zeiger = null;
          reihe.classList.remove('is-zieht');
        };
        ziehen.addEventListener('pointerup', los);
        ziehen.addEventListener('pointercancel', los);
      }

      zeichne();
    });

    // Der resize-Listener haengt am Fenster und darf deshalb NICHT an der
    // dataset.bound-Sperre der Reihe haengen: im Theme-Editor ersetzt Shopify
    // bei jeder Aenderung das Markup, die neue Reihe ist ungebunden und wuerde
    // einen zweiten Listener anmelden, waehrend der erste samt seiner Closure
    // auf die entfernte Reihe zeigt. Ein Modul-Flag plus frische Abfrage im
    // Listener loest beides. Dasselbe Muster wie bei bindRiesig.
    if (!streckeGebunden) {
      streckeGebunden = true;
      addEventListener('resize', () => bindStrecke());
    }
  }

  // Infopanels der Produktseite (snippets/nc-infopanel.liquid): der Versand-Link
  // in der Preiszeile (nc_price_note, zeigt auf die Versandrichtlinie) oeffnet
  // das Versand-Panel statt zu navigieren. Ohne JavaScript navigiert er weiter,
  // das ist der Fallback. Referenz: Bildschirmaufnahme vom 14.08.2026.
  function bindTaxLink() {
    const dlg = document.getElementById('NcPanelVersand');
    if (!dlg) return;
    $$('.nc-pdp__tax a[href*="shipping-policy"]').forEach((link) => {
      if (link.dataset.bound) return;
      link.dataset.bound = '1';
      link.addEventListener('click', (e) => { e.preventDefault(); dlg.showModal(); });
    });
  }

  // Kontakt-Panel (snippets/nc-kontakt-panel.liquid): der Kontakt-Textlink im
  // Hauptmenue oeffnet dasselbe Panel wie der Icon-Punkt darunter, statt auf
  // /pages/contact zu navigieren (ohne JavaScript navigiert er weiter). Nach
  // einem Formular-Submit laedt Shopify die Seite neu; steht die Erfolgs- oder
  // Fehlermeldung im Panel, oeffnet es sich von selbst, sonst saehe sie niemand.
  function bindKontakt() {
    const dlg = document.getElementById('NcPanelKontakt');
    if (!dlg) return;
    // Overlays stapeln sich bei der Referenz nie (Video-Vermessung 14.08.):
    // das Menue faehrt raus, waehrend das Panel hereinkommt, die zwei
    // Verdunkelungen ueberblenden. Deshalb schliesst jeder Panel-Ausloeser
    // im Menue das Menue mit.
    $$('[data-kontakt-open], [data-favoriten-open]').forEach((el) => {
      if (el.dataset.menuClose) return;
      el.dataset.menuClose = '1';
      el.addEventListener('click', () => document.getElementById('NcMenu')?.close());
    });
    $$('.nc-menu__link[href*="/pages/contact"]').forEach((link) => {
      if (link.dataset.bound) return;
      link.dataset.bound = '1';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementById('NcMenu')?.close();
        dlg.showModal();
      });
    });
    if (!dlg.dataset.autoOpen && dlg.querySelector('[data-nc-kontakt-erfolg]')) {
      dlg.dataset.autoOpen = '1';
      dlg.showModal();
    }
  }

  // Favoriten ohne Konto und ohne App: localStorage-Schluessel 'nc-favoriten',
  // Eintraege {handle, title, price, image, url}. Das Herz an der
  // Produktgalerie merkt und entfernt, das Panel (Menuepunkt Favoriten)
  // rendert die Liste bei jedem Oeffnen frisch.
  const FAV_KEY = 'nc-favoriten';
  function favListe() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function favSchreiben(liste) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(liste)); } catch (e) {}
  }
  function favRendern() {
    const ul = document.querySelector('[data-nc-fav-liste]');
    const leer = document.querySelector('[data-nc-fav-leer]');
    if (!ul || !leer) return;
    const liste = favListe();
    leer.hidden = liste.length > 0;
    const wegIcon = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="m4 4 12 12M16 4 4 16"/></svg>';
    ul.innerHTML = liste.map((f) => (
      '<li class="nc-fav__zeile">' +
      '<a href="' + f.url + '"><img class="nc-fav__bild" src="' + f.image + '" alt="" loading="lazy"></a>' +
      '<div class="nc-fav__meta"><a class="nc-fav__name" href="' + f.url + '">' + f.title + '</a>' +
      '<span class="nc-fav__preis">' + f.price + '</span></div>' +
      '<button class="nc-fav__weg" type="button" data-fav-weg="' + f.handle + '" aria-label="Entfernen">' + wegIcon + '</button>' +
      '</li>'
    )).join('');
  }
  function bindFavoriten() {
    const dlg = document.getElementById('NcPanelFavoriten');
    if (dlg && !dlg.dataset.favBound) {
      dlg.dataset.favBound = '1';
      $$('[data-favoriten-open]').forEach((el) =>
        el.addEventListener('click', () => favRendern())
      );
      dlg.addEventListener('click', (e) => {
        const weg = e.target.closest('[data-fav-weg]');
        if (!weg) return;
        favSchreiben(favListe().filter((f) => f.handle !== weg.dataset.favWeg));
        favRendern();
        const toggle = document.querySelector('[data-nc-fav-toggle][data-handle="' + weg.dataset.favWeg + '"]');
        if (toggle) { toggle.classList.remove('is-aktiv'); toggle.setAttribute('aria-pressed', 'false'); }
      });
    }
    const toggle = document.querySelector('[data-nc-fav-toggle]');
    if (!toggle || toggle.dataset.bound) return;
    toggle.dataset.bound = '1';
    const drin = favListe().some((f) => f.handle === toggle.dataset.handle);
    toggle.classList.toggle('is-aktiv', drin);
    toggle.setAttribute('aria-pressed', String(drin));
    toggle.addEventListener('click', () => {
      let liste = favListe();
      const war = liste.some((f) => f.handle === toggle.dataset.handle);
      if (war) {
        liste = liste.filter((f) => f.handle !== toggle.dataset.handle);
      } else {
        liste.push({
          handle: toggle.dataset.handle,
          title: toggle.dataset.title,
          price: toggle.dataset.price,
          image: toggle.dataset.image,
          url: toggle.dataset.url,
        });
      }
      favSchreiben(liste);
      toggle.classList.toggle('is-aktiv', !war);
      toggle.setAttribute('aria-pressed', String(!war));
    });
  }

  function init() {
    bindDialog('NcMenu', '[data-menu-open]');
    bindDialog('NcCartDrawer', '[data-cart-open]');
    bindDialog('NcPanelDetails', '[data-panel-details]');
    bindDialog('NcPanelVersand', '[data-panel-versand]');
    bindDialog('NcPanelTeilen', '[data-panel-teilen]');
    bindDialog('NcPanelKontakt', '[data-kontakt-open]');
    bindDialog('NcPanelFavoriten', '[data-favoriten-open]');
    bindKontakt();
    bindFavoriten();
    bindTaxLink();
    bindTeilen();
    bindProductForm();
    bindStickyCta();
    bindPdpSticky();
    bindPanels();
    bindBannerPolster();
    bindLogoTop();
    bindMehr();
    bindCardDots();
    bindVariants();
    bindRiesig();
    bindStrecke();
  }

  init();
  // Ohne diesen Listener ist im Theme-Editor nach jeder Aenderung alles tot.
  document.addEventListener('shopify:section:load', init);
})();
